if (!window.__noblShopPayLoaded) {
window.__noblShopPayLoaded = true;
// Override cart drawer's contains method during Shop Pay
(function() {
  let initialized = false;
  let functionalButton = null;
  let eventListenersAttached = false;
  let originalContains = null;
  let shopPayActive = false;

  function findFunctionalButton() {
    const paymentTermsContainer = document.getElementById('payment-terms-functional');
    if (!paymentTermsContainer) return null;

    const paymentTermsElement = paymentTermsContainer.querySelector('payment-terms');
    if (!paymentTermsElement) return null;

    let button = null;

    if (paymentTermsElement.shadowRoot) {
      button = paymentTermsElement.shadowRoot.querySelector('button[data-testid="shopify-installments-cta"]') ||
               paymentTermsElement.shadowRoot.querySelector('button[id*="installments"]') ||
               paymentTermsElement.shadowRoot.querySelector('button');
    }

    if (!button) {
      const shopifyElement = paymentTermsElement.querySelector('shopify-payment-terms');
      if (shopifyElement && shopifyElement.shadowRoot) {
        button = shopifyElement.shadowRoot.querySelector('button[data-testid="shopify-installments-cta"]') ||
                 shopifyElement.shadowRoot.querySelector('button[id*="installments"]') ||
                 shopifyElement.shadowRoot.querySelector('button');
      }
    }

    return button;
  }

  function overrideCartDrawerContains() {
    const cartDrawer = document.querySelector('cart-drawer#cart-drawer') || 
                      document.querySelector('cart-drawer');
    
    if (!cartDrawer || originalContains) return;
    
    originalContains = cartDrawer.contains;
    
    cartDrawer.contains = function(element) {
      if (shopPayActive) {
        return true;
      }
      return originalContains.call(this, element);
    };
  }

  function restoreCartDrawerContains() {
    const cartDrawer = document.querySelector('cart-drawer#cart-drawer') || 
                      document.querySelector('cart-drawer');
    
    if (!cartDrawer || !originalContains) return;

    cartDrawer.contains = originalContains;
    originalContains = null;
  }

  function startShopPayMode() {
    shopPayActive = true;
    overrideCartDrawerContains();
  }

  function stopShopPayMode() {
    shopPayActive = false;
    restoreCartDrawerContains();
  }

  function monitorShopPayPopup() {
    let noPopupCount = 0;
    const maxNoPopupCount = 8; // 4 seconds of no popup
    
    const checkInterval = setInterval(() => {
      // Look for visible modals/popups
      const modals = document.querySelectorAll('iframe, [role="dialog"], [aria-modal="true"], .modal, [class*="modal"], [id*="modal"]');
      let hasVisibleModal = false;
      
      for (let modal of modals) {
        const rect = modal.getBoundingClientRect();
        if (rect.width > 100 && rect.height > 100 && 
            modal.style.display !== 'none' &&
            !modal.hasAttribute('aria-hidden')) {
          hasVisibleModal = true;
          break;
        }
      }
      
      if (!hasVisibleModal) {
        noPopupCount++;
      } else {
        noPopupCount = 0;
      }
      
      // If no popup for several consecutive checks, stop Shop Pay mode
      if (noPopupCount >= maxNoPopupCount && shopPayActive) {
        stopShopPayMode();
        clearInterval(checkInterval);
        return;
      }
      
      if ((checkInterval._count || 0) > 240) {
        stopShopPayMode();
        clearInterval(checkInterval);
      }
      
      checkInterval._count = (checkInterval._count || 0) + 1;
    }, 500);
  }

  function currentTermsElement() {
    return document.querySelector('#payment-terms-functional shopify-payment-terms');
  }

  function triggerShopPayPopup() {
    // The hidden Shopify widget is rebuilt every time the drawer re-renders (add to
    // cart, then again after the gift sync). Its popup lives inside that element, so a
    // click on an element that is about to be replaced opens a popup that vanishes.
    // So: wait until the element has a button and has stayed the same for a moment,
    // click it, and if it gets replaced right after, click the new one.
    const STABLE_MS = 1200;
    const MAX_WAIT_MS = 9000;
    const started = Date.now();
    let lastEl = null;
    let stableSince = 0;
    let reclicks = 0;

    function openOn(el) {
      functionalButton = findFunctionalButton();
      if (!functionalButton) return false;
      startShopPayMode();
      functionalButton.click();
      return true;
    }

    function watchForReplacement(clickedEl) {
      const watchUntil = Date.now() + 8000;
      const w = setInterval(() => {
        if (Date.now() > watchUntil || reclicks >= 2) { clearInterval(w); return; }
        const now = currentTermsElement();
        if (now && now !== clickedEl) {
          clearInterval(w);
          reclicks++;
          waitThenClick(true);
        }
      }, 250);
    }

    function waitThenClick(isRetry) {
      const tick = () => {
        const el = currentTermsElement();
        const ready = !!(el && findFunctionalButton());
        if (ready && el === lastEl) {
          if (!stableSince) stableSince = Date.now();
        } else {
          stableSince = 0;
          lastEl = el;
        }
        const timedOut = Date.now() - started > MAX_WAIT_MS && !isRetry;
        if (ready && (stableSince && Date.now() - stableSince >= STABLE_MS || timedOut)) {
          const clickedEl = currentTermsElement();
          if (openOn(clickedEl)) {
            setTimeout(monitorShopPayPopup, 2000);
            watchForReplacement(clickedEl);
          }
          return;
        }
        if (!isRetry && !ready && Date.now() - started > MAX_WAIT_MS * 2) {
          window.location.href = '/checkout';
          return;
        }
        setTimeout(tick, 200);
      };
      stableSince = 0;
      lastEl = null;
      tick();
    }

    waitThenClick(false);
  }

  function attachEventListeners() {
    if (eventListenersAttached) return;

    document.addEventListener('click', function(e) {
      if (e.target.matches('[data-shop-pay-action="learn-more"]') || 
          e.target.closest('#shop-pay-banner-clickable')) {
        e.preventDefault();
        e.stopPropagation();
        triggerShopPayPopup();
      }
    });

    eventListenersAttached = true;
  }

  function initShopPayFunctionality() {
    const staticBanner = document.getElementById('shop-pay-banner-clickable');
    const learnMoreBtn = document.querySelector('.shop-pay-cta-btn');

    if (!staticBanner || !learnMoreBtn) {
      return false;
    }

    attachEventListeners();
    initialized = true;
    return true;
  }

  // Initialize. The click listener is delegated on document, so attach it right away:
  // the Shop Pay banner may only arrive later (empty cart at load, then add to cart).
  attachEventListeners();
  initialized = true;

  // Re-initialize on cart events (but restore contains first)
  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(eventName => {
    document.addEventListener(eventName, function() {
      if (!shopPayActive) {
        restoreCartDrawerContains();
        initialized = true;
      }
    });
  });

  // Hide competing content
  setInterval(() => {
    ['#extracted-payment-terms', '#payment-content-display', '.payment-terms-stable'].forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        if (element && !element.closest('.cart-payment-terms-wrapper')) {
          element.style.display = 'none';
        }
      });
    });
  }, 5000);
})();
}
